import {
  BotMessageSquare,
  ChevronLeft,
  ChevronRight,
  Download,
  ExternalLink,
  Loader2Icon,
  LucideProps,
  RefreshCw,
  Share,
  User,
  X,
  MoreVertical,
} from "lucide-react";
import { MouseEventHandler, ReactNode } from "react";
import { cn } from "../../utils/classes";
import { ColorType } from "../../utils/theme/colors";
import Add from "./svg/add.svg?react";
import ArrowUp from "./svg/arrow-up.svg?react";
import Company from "./svg/company.svg?react";
import Delete from "./svg/delete.svg?react";
import DOCIcon from "./svg/doc.svg?react";
import Filter from "./svg/filter.svg?react";
import GBP from "./svg/gbp.svg?react";
import ImageIcon from "./svg/image.svg?react";
import Maximise from "./svg/maximise.svg?react";
import PDFIcon from "./svg/pdf.svg?react";
import QuestionMark from "./svg/question-mark.svg?react";
import Search from "./svg/search.svg?react";

const iconMap = {
  "": null,
  Add,
  "Chevron Right": ChevronRight,
  "Chevron Left": ChevronLeft,
  Company,
  Filter,
  Loader: Loader2Icon,
  Trash: Delete,
  User,
  X: X,
  ArrowUp,
  ImageIcon,
  PDFIcon,
  DOCIcon,
  Maximise,
  ExternalLink,
  RefreshCw,
  Download,
  Search,
  Share,
  BotMessageSquare,
  GBP,
  QuestionMark,
  MoreVertical,
};

export type IconType = keyof typeof iconMap;

export const isIconType = (icon: ReactNode): icon is IconType => {
  return typeof icon === "string" && icon in iconMap;
};

export type IconProp = {
  type: IconType;
  fillPath?: string;
  className?: string;
  color?: ColorType | string;
  width?: number;
  height?: number;
  strokeWidth?: number;
  onClick?: MouseEventHandler<SVGSVGElement>;
  title?: string;
} & LucideProps;

export const Icon = ({
  onClick,
  strokeWidth,
  width,
  height,
  className,
  color,
  title,
  type = "Filter",
  ...props
}: IconProp) => {
  const IconSVG = iconMap[type];
  if (!IconSVG) {
    return (
      <div
        title={title}
        className={cn(className, "rounded-full bg-neutral-300")}
      />
    );
  }

  return (
    <IconSVG
      title={title}
      width={width}
      height={height}
      onClick={onClick}
      color={color}
      strokeWidth={strokeWidth}
      className={cn(className, { "animate-spin": type === "Loader" })}
      {...props}
    />
  );
};
